const Linkup = function(){

	const run = () => {
		this.$body = $('body');
		this.$linkup = this.$body.find('.js-link-up');

		this.$linkup.addClass('cursor-pointer');

		this.$linkup.on('click', (e) => {
			//e.preventDefault();
			const $this = $(e.currentTarget);
			const link = $this.find('a').attr('href');
			nav.change(link);
		});
	}

	this.run = () => run();
}